(function ($) {

   // Slidenav Accordions
   setupSlideNavEvents('profile');


   $( ".action-slidenav" ).on('click',function() {
      var action = $(this).attr('data-menu');
      var overlay = $( ".ptx-site").attr("data-overlay");
      $('.ptx-slidenav__listitem').not('[data-hide-pro]').removeClass('active');
      // alert("Action is " + action);

      var state = (overlay != action) ? action : "none";
      // var navIsShowing = $('.gm-bignav').hasClass('gm-bignav--showing');
      var navIsShowing = state == action;
      $( ".ptx-site").attr("data-overlay",state);

      // Load External Nav
      loadExternalNav();

     if(navIsShowing){
      // $('body').addClass('noscroll');
       ptxStdLib.setNavOpen(true);

     } else {
       // $('body').removeClass('noscroll');
       ptxStdLib.setNavOpen(false);
     }

   });

   // Footer Controls
   $('input[type=radio][name=footer_placement]').on('change', function() {
      var currentValue = $(this).val();
      var $currentNav = $('.ptx-tinyfooternav');
      var classList = 'ptx-tinyfooternav--fixed ptx-tinyfooternav--inset ptx-tinyfooternav--dynamicisland';
      $currentNav.removeClass(classList);
      switch (currentValue) {
         case 'end':
            $currentNav.addClass();
            break;
         case 'bottom':
            $currentNav.addClass('ptx-tinyfooternav--fixed');
            break;
         case 'inset':
            $currentNav.addClass('ptx-tinyfooternav--inset');
            break;
         case 'island':
            $currentNav.addClass('ptx-tinyfooternav--dynamicisland');
            break;
      }
    });

    // Header Controls
    $('input[type=radio][name=header_placement]').on('change', function() {
      var currentValue = $(this).val();
      var $currentNav = $('.ptx-primarynav');
      var classList = 'ptx-primarynav--fixed ptx-primarynav--hidey';
      $currentNav.removeClass(classList);
      switch (currentValue) {
         case 'top': $currentNav.addClass('ptx-primarynav--fixed'); break;
         case 'dynamic': $currentNav.addClass('ptx-primarynav--hidey'); break;
      }
    });


   function loadExternalNav(){
      if(ptxStdLib.userInterface.navloaded === false){
         // alert('before');
         console.log(ptxsite);
         var navPath = ptxsite.baseurl + "/navigation/";
         // alert(navPath);
         $.get( navPath, function( data ) {
            $( ".ptx-slidenav--main .ptx-slidenav__content" ).html( data );
            // alert( "Load was performed." );
            ptxStdLib.userInterface.navloaded = true;
            setupSlideNavEvents('main');
         });
      }
   }


   function setupSlideNavEvents(modifier){
      var selector = ".ptx-slidenav--"+modifier+" button";

      $(selector).on('click',function() {
         var parentClass = 'active';
         var $parent = $(this).closest('li');
         var hadClass = $parent.hasClass(parentClass);

         if(hadClass){
         $parent.toggleClass(parentClass);
         }

         if(!hadClass){
            $(".ptx-slidenav__listitem" ).removeClass(parentClass);
            $parent.addClass(parentClass);
         }
         
   });

   if(modifier=="main"){
      initializeAlphaSorter();
   }
   }
  
})(jQuery);
   
